var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeacon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.435,
    height: 63.957,
    viewBox: "0 0 215.435 63.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(4563.607 11793.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-4507.826 -11789.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M304.671,123.8h-7.04V102.1h6.054c2.892,0,6.088,1.869,6.088,5.68a4.14,4.14,0,0,1-2.006,3.809,5.963,5.963,0,0,1,4.014,5.611c0,4.49-3.741,6.6-7.11,6.6m-1.529-18.979H300.76v5.85h2.382c1.8,0,3.367-.851,3.367-2.891,0-2.075-1.565-2.959-3.367-2.959m.849,8.5H300.76v7.756h3.231c2.314,0,4.49-1.191,4.49-3.878,0-2.618-2.177-3.877-4.49-3.877",
    transform: "translate(-297.631 -101.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M362.51,123.8V102.1h11.7v2.822h-8.4v6.565h7.04v2.823h-7.04v6.667H375.4V123.8Z",
    transform: "translate(-345.131 -101.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M434.187,122.958l-2.348-5.611H423.4l-2.347,5.611h-3.231l9.251-22.007h1.191l9.252,22.007Zm-5.612-13.537a26.715,26.715,0,0,1-.919-2.654h-.067a20.157,20.157,0,0,1-.918,2.654l-2.143,5.305h6.19Z",
    transform: "translate(-385.63 -100.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M507.088,105.652a10.838,10.838,0,0,0-5.375-1.394c-4.149,0-8.537,2.687-8.537,8.2,0,5.475,4.285,8.164,8.537,8.164a10.875,10.875,0,0,0,5.543-1.226l-.305,2.993a11.351,11.351,0,0,1-5.611,1.022c-5.375,0-11.5-3.741-11.5-11.021,0-7.381,6.191-11.054,11.5-11.054a12.88,12.88,0,0,1,6.326,1.394Z",
    transform: "translate(-438.354 -101.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M574.847,123a11.277,11.277,0,1,1,11.5-11.292A11.23,11.23,0,0,1,574.847,123m0-19.626a8.422,8.422,0,1,0,8.161,8.4,8.125,8.125,0,0,0-8.161-8.4",
    transform: "translate(-492.17 -100.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M679.7,124.273l-10.169-11.122c-1.634-1.769-3.5-3.946-5-5.714l-.068.032c.068,1.974.068,3.81.068,5.443V123.8h-3.3V102.1h2.28l9.319,10.2c1.258,1.394,3.232,3.572,4.558,5.2l.069-.034c-.069-1.668-.069-3.537-.069-5.1V102.1h3.3v22.175Z",
    transform: "translate(-563.835 -101.656)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-4509.244 -11759.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M297.878,292.416l-.794-1.9h-2.857l-.794,1.9h-1.1l3.133-7.453h.4l3.134,7.453Zm-1.9-4.584a9.013,9.013,0,0,1-.312-.9h-.022a6.956,6.956,0,0,1-.311.9l-.726,1.8h2.1Z",
    transform: "translate(-292.337 -265.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M549.439,286.308v2.224h2.488v.955h-2.488V292.7h-1.117v-7.35h4.066v.956Z",
    transform: "translate(-479.75 -266.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M566.71,286.059a.968.968,0,0,1-.633-.634.943.943,0,0,1,.633-.634.923.923,0,0,1,.633.634.946.946,0,0,1-.633.634m-.53,1.014h1.06v5.218h-1.06Z",
    transform: "translate(-492.749 -265.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M579.045,298.18v-3.352a1.073,1.073,0,0,0-1.211-1.095,1.132,1.132,0,0,0-1.255,1.095v3.352H575.53v-5.218h.957v.679h.011a1.614,1.614,0,0,1,1.613-.806,1.838,1.838,0,0,1,1.98,1.889v3.456Z",
    transform: "translate(-499.67 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M600.335,298.307a1.09,1.09,0,0,1-.828-.819,1.367,1.367,0,0,1-1.4.819,1.6,1.6,0,0,1-1.681-1.6,1.725,1.725,0,0,1,1.716-1.67l1.221-.116v-.334c0-.472-.277-.853-1.013-.853a2.711,2.711,0,0,0-1.441.415l-.205-.863a3.086,3.086,0,0,1,1.705-.45,1.809,1.809,0,0,1,2,1.89v2.108a.737.737,0,0,0,.588.8Zm-.968-2.524-1,.092c-.668.057-.933.46-.933.84a.724.724,0,0,0,.772.7,1.148,1.148,0,0,0,1.163-1.175Z",
    transform: "translate(-514.971 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M619.806,298.18v-3.352a1.073,1.073,0,0,0-1.209-1.095,1.133,1.133,0,0,0-1.257,1.095v3.352h-1.047v-5.218h.956v.679h.011a1.614,1.614,0,0,1,1.613-.806,1.839,1.839,0,0,1,1.982,1.889v3.456Z",
    transform: "translate(-529.514 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M641.429,294.384a2.4,2.4,0,0,0-1.381-.391,1.757,1.757,0,1,0,.021,3.513,2.877,2.877,0,0,0,1.36-.322l-.1.967a3.283,3.283,0,0,1-1.348.254,2.681,2.681,0,1,1,0-5.358,3.308,3.308,0,0,1,1.647.381Z",
    transform: "translate(-544.814 -271.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M658.242,286.059a.968.968,0,0,1-.633-.634.944.944,0,0,1,.633-.634.922.922,0,0,1,.633.634.945.945,0,0,1-.633.634m-.53,1.014h1.06v5.218h-1.06Z",
    transform: "translate(-559.762 -265.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M669.9,298.307a1.094,1.094,0,0,1-.83-.819,1.365,1.365,0,0,1-1.393.819,1.6,1.6,0,0,1-1.681-1.6,1.724,1.724,0,0,1,1.716-1.67l1.222-.116v-.334c0-.472-.277-.853-1.014-.853a2.708,2.708,0,0,0-1.441.415l-.207-.863a3.091,3.091,0,0,1,1.705-.45,1.81,1.81,0,0,1,2,1.89v2.108a.735.735,0,0,0,.588.8Zm-.968-2.524-1,.092c-.669.057-.933.46-.933.84a.724.724,0,0,0,.771.7,1.149,1.149,0,0,0,1.164-1.175Z",
    transform: "translate(-565.902 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M686.977,290.578a1.392,1.392,0,0,1-1.037-1.44v-6.97h1.048V289a.889.889,0,0,0,.7.864Z",
    transform: "translate(-580.504 -263.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M710.782,286.556a3.667,3.667,0,0,0-1.819-.473,2.773,2.773,0,1,0,0,5.541,3.7,3.7,0,0,0,1.878-.414l-.105,1.013a3.844,3.844,0,0,1-1.9.346,3.741,3.741,0,1,1,0-7.476,4.369,4.369,0,0,1,2.142.472Z",
    transform: "translate(-594.416 -265.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M733.04,298.306a2.737,2.737,0,1,1,2.765-2.731,2.677,2.677,0,0,1-2.765,2.731m0-4.528a1.818,1.818,0,1,0,1.7,1.82,1.732,1.732,0,0,0-1.7-1.82",
    transform: "translate(-612.955 -271.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M761.519,298.18v-3.352c0-.542-.184-1.095-1.131-1.095a1.025,1.025,0,0,0-1.173,1.095v3.352h-1.049v-3.352c0-.542-.185-1.095-1.129-1.095a1.025,1.025,0,0,0-1.175,1.095v3.352h-1.049v-5.218h.968v.679h.011a1.516,1.516,0,0,1,1.533-.806,1.755,1.755,0,0,1,1.543.772,2.088,2.088,0,0,1,1.694-.772,1.823,1.823,0,0,1,2,1.889v3.456Z",
    transform: "translate(-630.929 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M790.934,298.306a2.349,2.349,0,0,1-1.406-.439v2.973H788.48v-7.879h.991v.575h.011a1.829,1.829,0,0,1,1.577-.7,2.742,2.742,0,0,1-.125,5.473m-.105-4.528a1.529,1.529,0,0,0-1.3.668v2.442a1.737,1.737,0,0,0,1.3.519,1.819,1.819,0,0,0,0-3.629",
    transform: "translate(-655.576 -271.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M814.439,298.307a1.092,1.092,0,0,1-.83-.819,1.363,1.363,0,0,1-1.393.819,1.6,1.6,0,0,1-1.682-1.6,1.724,1.724,0,0,1,1.715-1.67l1.223-.116v-.334c0-.472-.277-.853-1.014-.853a2.7,2.7,0,0,0-1.439.415l-.208-.863a3.091,3.091,0,0,1,1.7-.45,1.81,1.81,0,0,1,2.006,1.89v2.108a.736.736,0,0,0,.587.8Zm-.968-2.524-1,.092c-.667.057-.932.46-.932.84a.724.724,0,0,0,.772.7,1.148,1.148,0,0,0,1.163-1.175Z",
    transform: "translate(-671.722 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M833.912,298.18v-3.352a1.073,1.073,0,0,0-1.209-1.095,1.131,1.131,0,0,0-1.255,1.095v3.352H830.4v-5.218h.957v.679h.01a1.614,1.614,0,0,1,1.613-.806,1.84,1.84,0,0,1,1.982,1.889v3.456Z",
    transform: "translate(-686.266 -271.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M852.815,298.021c-.783,1.925-1.636,2.765-2.662,3.227l-.667-.669a4.062,4.062,0,0,0,2.258-2.511L849.8,293.31h1.081l.958,2.361c.125.323.31.784.436,1.2h.024c.151-.392.345-.876.473-1.187l.968-2.372h1Z",
    transform: "translate(-700.241 -271.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M364.244,294.975a4.539,4.539,0,0,1-1.2.038,1.438,1.438,0,0,1-1.408-.878,2.269,2.269,0,0,1-1.812.923,1.526,1.526,0,0,1-1.577-1.518c0-.966.389-1.358,1.879-1.825.5-.155.98-.272,1.49-.388l0-.8c0-1.11-.441-1.359-1-1.36a.988.988,0,0,0-.3.039c-.238,1.436-.526,1.826-1.048,1.826a.776.776,0,0,1-.8-.8c0-.589,1.14-1.708,3.006-1.7,1.58,0,2.193.606,2.191,1.859l-.007,3.629c0,.34.057.61.314.66a1.047,1.047,0,0,0,.268.034Zm-2.627-3.269a8.642,8.642,0,0,0-.863.351c-.536.272-.811.546-.811,1a1.021,1.021,0,0,0,1.094.966,1.793,1.793,0,0,0,.575-.064Z",
    transform: "translate(-340.593 -268.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M392.53,294.958c-.248,0-1.178-.015-1.7-.016s-1.365.01-1.662.01v-.261l.148-.04c.447-.116.559-.338.562-1.487l0-2.259c0-.849-.282-1.254-.915-1.256a2.042,2.042,0,0,0-.856.169,3.33,3.33,0,0,1,.048.64l0,2.454c0,1.45.108,1.62.555,1.738l.148.04v.261c-.248,0-1.178-.016-1.7-.016s-1.363.01-1.662.009v-.261l.148-.039c.447-.117.559-.338.562-1.488l0-2.258c0-.85-.282-1.377-.914-1.378a2.279,2.279,0,0,0-.807.142l-.008,3.491c0,1.149.11,1.372.555,1.49l.149.039v.262c-.285,0-1.215-.016-1.736-.017s-1.4.01-1.663.01v-.261l.224-.052c.408-.091.521-.312.524-1.723l0-2.3c0-.744-.11-.966-.506-1.229l-.235-.156v-.087l2.469-.653.223.157,0,.823a3.3,3.3,0,0,1,2.086-.949,1.375,1.375,0,0,1,1.474,1.061,3.363,3.363,0,0,1,2.2-1.053c1.067,0,1.586.657,1.583,1.949l0,2.455c0,1.449.109,1.619.555,1.737l.148.04Z",
    transform: "translate(-357.827 -268.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M432.63,295.041c-.248,0-1.179-.015-1.7-.017s-1.365.011-1.662.011v-.261l.149-.04c.447-.116.559-.338.561-1.487l0-2.259c0-.849-.283-1.254-.915-1.256a2.042,2.042,0,0,0-.856.169,3.421,3.421,0,0,1,.048.64l0,2.454c0,1.451.109,1.62.555,1.738l.148.039v.262c-.248,0-1.179-.016-1.7-.016s-1.364.01-1.662.009v-.261l.148-.038c.447-.118.558-.339.561-1.489l0-2.258c0-.85-.282-1.377-.915-1.378a2.292,2.292,0,0,0-.806.142l-.008,3.491c0,1.149.109,1.372.555,1.49l.148.04v.261c-.285,0-1.215-.016-1.736-.017s-1.4.01-1.662.01v-.261l.224-.052c.409-.091.522-.312.524-1.723l0-2.3c0-.744-.109-.966-.506-1.229l-.235-.156v-.087l2.469-.653.223.157,0,.822a3.3,3.3,0,0,1,2.086-.949,1.374,1.374,0,0,1,1.474,1.061,3.361,3.361,0,0,1,2.2-1.053c1.067,0,1.586.657,1.583,1.949l0,2.455c0,1.449.109,1.619.555,1.738l.149.039Z",
    transform: "translate(-387.185 -268.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M465.287,295.148a3.094,3.094,0,0,1-3.374-3.337,3.214,3.214,0,0,1,3.414-3.257,3.1,3.1,0,0,1,3.376,3.336,3.216,3.216,0,0,1-3.416,3.257m-.1-6.124c-.731,0-1.072.546-1.075,2.283,0,2.1.4,3.369,1.325,3.371.731,0,1.072-.546,1.075-2.282,0-2.1-.4-3.37-1.325-3.372",
    transform: "translate(-416.488 -268.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M494.338,295.167c-.261,0-1.241-.015-1.79-.017s-1.436.011-1.749.01V294.9l.157-.039c.47-.117.588-.338.59-1.487l0-2.259c0-.849-.349-1.377-1.016-1.377a2.512,2.512,0,0,0-.849.142l-.007,3.491c0,1.149.114,1.371.584,1.489l.157.04v.261c-.3,0-1.227-.016-1.775-.017s-1.528.011-1.8.01v-.261l.235-.052c.431-.091.55-.312.552-1.723l0-2.3c0-.744-.116-.966-.533-1.228l-.247-.158v-.086l2.6-.653.234.158,0,.823a3.556,3.556,0,0,1,2.2-.949c1.123,0,1.723.657,1.719,1.95l0,2.454c0,1.449.114,1.62.583,1.738l.157.04Z",
    transform: "translate(-434.739 -268.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M518.295,295.295a6.068,6.068,0,0,1-2.31-.461l.493-1.671h.229c.22,1.045.845,1.673,1.706,1.675.641,0,1.02-.351,1.021-.859s-.246-.772-1.329-1.1c-1.592-.486-2.075-1.048-2.072-2.106a2.222,2.222,0,0,1,2.445-2.019,4.6,4.6,0,0,1,2.036.435l-.492,1.591h-.242c-.207-1.005-.649-1.567-1.419-1.569a.809.809,0,0,0-.876.82c0,.588.258.8,1.329,1.125,1.593.486,2.061,1.062,2.06,2.054,0,1.345-1.206,2.087-2.578,2.083",
    transform: "translate(-456.075 -268.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M333.831,287.722a9.916,9.916,0,0,1-3.513-.776l.658-2.12h.24A2.355,2.355,0,0,0,334,287.2a1.744,1.744,0,0,0,1.69-1.461c0-.739-.594-1.214-2.126-1.68-2.254-.688-2.936-1.361-2.932-2.858s1.372-2.739,3.461-2.735a6.508,6.508,0,0,1,2.881.616l-.673,2.009h-.244c-.14-1.461-.687-2.186-2.132-2.1a1.617,1.617,0,0,0-1.486,1.406c0,.831.613,1.128,2.127,1.595,2.252.688,2.916,1.5,2.914,2.905,0,1.9-1.707,2.831-3.647,2.827",
    transform: "translate(-320.144 -260.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M300.164,215.541a4.925,4.925,0,0,0-2.44-.632,3.716,3.716,0,1,0,0,7.426,4.93,4.93,0,0,0,2.515-.558l-.138,1.359a5.15,5.15,0,0,1-2.546.464,5.013,5.013,0,1,1,0-10.018,5.86,5.86,0,0,1,2.871.632Z",
    transform: "translate(-292.336 -213.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M333.533,223.395l-1.065-2.546h-3.827l-1.065,2.546h-1.467l4.2-9.988h.539l4.2,9.988Zm-2.548-6.143a12.031,12.031,0,0,1-.415-1.205h-.032a8.99,8.99,0,0,1-.417,1.205l-.972,2.406h2.811Z",
    transform: "translate(-317.061 -213.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M367.493,219.454h-1.636v4.322h-1.481v-9.847h3.117a2.77,2.77,0,1,1,0,5.526m-.262-4.229h-1.374v2.995h1.374a1.509,1.509,0,1,0,0-2.995",
    transform: "translate(-345.078 -213.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 1.498,
    height: 9.847,
    transform: "translate(27.077 0.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M408.287,215.209v8.567h-1.5v-8.567h-3.163v-1.281h7.825v1.281Z",
    transform: "translate(-373.815 -213.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M437.382,223.395l-1.066-2.546h-3.827l-1.065,2.546h-1.467l4.2-9.988h.54l4.2,9.988Zm-2.549-6.143a11.835,11.835,0,0,1-.415-1.205h-.031a9.107,9.107,0,0,1-.417,1.205L433,219.658h2.811Z",
    transform: "translate(-393.091 -213.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M468.226,223.777V213.93h1.5V222.5h4.338v1.281Z",
    transform: "translate(-421.11 -213.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M515.988,223.777l-.4-4.444c-.06-.664-.122-1.513-.154-2.24h-.03c-.309.695-.788,1.652-1.113,2.284l-2.285,4.477h-.554l-2.317-4.477c-.339-.649-.757-1.527-1.1-2.254h-.032c-.029.757-.106,1.621-.152,2.209l-.387,4.444h-1.327l.849-9.847h.926l2.624,5.063c.387.755.911,1.774,1.235,2.53h.032c.308-.756.788-1.713,1.2-2.53l2.593-5.063h.928l.879,9.847Z",
    transform: "translate(-448.868 -213.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M559.384,223.395l-1.066-2.546h-3.827l-1.066,2.546H551.96l4.2-9.988h.539l4.2,9.988Zm-2.547-6.143a12.217,12.217,0,0,1-.418-1.205h-.03a9.121,9.121,0,0,1-.415,1.205L555,219.658h2.81Z",
    transform: "translate(-482.414 -213.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M598.6,223.994l-4.616-5.046c-.74-.8-1.588-1.792-2.269-2.592l-.03.014c.03.9.03,1.728.03,2.47v4.94h-1.5v-9.847h1.035l4.229,4.63c.572.632,1.468,1.621,2.069,2.362l.031-.015c-.031-.757-.031-1.605-.031-2.315v-4.661h1.5v10.063Z",
    transform: "translate(-510.425 -213.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M635.511,223.395l-1.065-2.546h-3.827l-1.066,2.546h-1.465l4.2-9.988h.539l4.2,9.988Zm-2.546-6.143a12.015,12.015,0,0,1-.418-1.205h-.032a8.985,8.985,0,0,1-.414,1.205l-.973,2.406h2.808Z",
    transform: "translate(-538.148 -213.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M668.528,223.415a5.121,5.121,0,1,1-.092-10.232,6,6,0,0,1,3.179.786l-.277,1.327a5.191,5.191,0,0,0-2.734-.787,3.777,3.777,0,0,0-3.966,3.844,3.727,3.727,0,0,0,3.981,3.8,3.672,3.672,0,0,0,2.085-.508v-2.178h-2.269v-1.2h3.69v4.093a5.534,5.534,0,0,1-3.6,1.063",
    transform: "translate(-563.801 -213.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M703.642,223.777V213.93h5.31v1.281h-3.813v2.979h3.195v1.281h-3.195V222.5h4.354v1.281Z",
    transform: "translate(-593.464 -213.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M738.213,223.777l-.4-4.444c-.062-.664-.125-1.513-.155-2.24h-.03c-.311.695-.788,1.652-1.112,2.284l-2.284,4.477h-.556l-2.314-4.477c-.34-.649-.757-1.527-1.1-2.254h-.032c-.03.757-.108,1.621-.155,2.209l-.384,4.444h-1.327l.848-9.847h.926l2.624,5.063c.387.755.911,1.774,1.237,2.53h.028c.309-.756.788-1.713,1.205-2.53l2.593-5.063h.926l.88,9.847Z",
    transform: "translate(-611.565 -213.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M776.769,223.777V213.93h5.31v1.281h-3.811v2.979h3.194v1.281h-3.194V222.5h4.352v1.281Z",
    transform: "translate(-647.002 -213.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M811.026,223.994l-4.615-5.046c-.741-.8-1.589-1.792-2.269-2.592l-.031.014c.031.9.031,1.728.031,2.47v4.94h-1.5v-9.847h1.034l4.229,4.63c.57.632,1.466,1.621,2.069,2.362l.03-.015c-.03-.757-.03-1.605-.03-2.315v-4.661h1.5v10.063Z",
    transform: "translate(-665.946 -213.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M844.307,215.209v8.567h-1.5v-8.567h-3.163v-1.281h7.826v1.281Z",
    transform: "translate(-693.035 -213.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M874.832,216.324a1.35,1.35,0,0,1-.7-.182l-.047-.439a1.314,1.314,0,0,0,.773.257c.3,0,.5-.167.5-.413s-.143-.392-.468-.5c-.487-.157-.744-.4-.744-.8a.766.766,0,0,1,.865-.744,1.1,1.1,0,0,1,.6.156l-.084.353a1,1,0,0,0-.529-.16.4.4,0,0,0-.444.364c0,.2.147.321.434.417.474.16.8.382.8.873s-.326.817-.943.817",
    transform: "translate(-718.247 -213.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M884.565,216.373l-.112-1.252c-.018-.186-.035-.425-.043-.631h-.01c-.086.2-.221.466-.313.644l-.642,1.26h-.158l-.653-1.26c-.1-.183-.211-.43-.307-.634h-.009c-.008.212-.029.456-.044.621l-.108,1.252h-.373l.238-2.773h.26l.739,1.426c.109.213.256.5.348.713h.008c.089-.214.221-.482.339-.713l.731-1.426h.26l.249,2.773Z",
    transform: "translate(-723.894 -213.488)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M23.941,49.373A23.913,23.913,0,0,1,8.192,43.439c-2.293.692-4.049,1.408-4.049,1.408,9.9-6.388,27.947-20.953,37-34A94.137,94.137,0,0,0,46.825.714,13,13,0,0,1,47.7,9.67c-1.652,6.477,1.392,8.679-.087,11.473a4.72,4.72,0,0,1-.276.451,2.424,2.424,0,0,1-1.045.846c-1.324.582-3.281.285-5.154-.012-2.143-.339-4.178-.679-5.03.3-1.833,2.1,7.836,4.193,7.357,5.776s-5.882,2.51-8.107,4.524S34,38.658,29.094,36.853s-5.1-3.7-5.1-1.147,2.167,3.744,3.787,4.6.635,2.492-2.579,2.3a8.9,8.9,0,0,0-2.785.3,6.939,6.939,0,0,1-5.149-.4c-1.371-.565-3.535-.388-5.713.056.86,2.8,8.126,5.287,12.391,5.3A22.487,22.487,0,0,0,46.479,25.429c0-.56-.02-1.118-.059-1.671a3.318,3.318,0,0,0,.561-.188,2.467,2.467,0,0,0,.877-.631,24.559,24.559,0,0,1,.125,2.495A23.971,23.971,0,0,1,24,49.373ZM1.867,34.676A23.826,23.826,0,0,1,0,25.426v-.092A23.97,23.97,0,0,1,23.99,1.393h.05a24.039,24.039,0,0,1,5.611.67,2.566,2.566,0,0,0-.986.517,1.592,1.592,0,0,0-.456.709,22.6,22.6,0,0,0-4.172-.395A22.489,22.489,0,0,0,1.5,25.337c-.01,5.1,5.139,15.645,8.76,11.693,2.742-4.494,1.869-5.556,1.789-8.871s1.392-7.744,2.518-7.985c.512-.11.91,1.534,1.341,3.176C16.43,25.324,17,27.3,17.865,26.233c1.592-1.95-.265-6.43-.669-9.166s.828-3.187,2.549-3.871,1.93-6.2,3.8-6.647,3.375,9.373,4.16,10.829,3-6.9,1.676-11.115c-.418-1.335-.226-2.141.322-2.637a4.4,4.4,0,0,1,2.521-.781c1.136-.1,2.4-.093,3.431-.282C38.178,2.1,45.577.044,45.735,0h0a66.1,66.1,0,0,1-5.532,9.8C36.067,16.16,26.534,26.569,15.4,35.038l-9,6.686A26.8,26.8,0,0,1,1.867,34.676Z",
    transform: "translate(-4563.607 -11793.815)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeacon);
export default __webpack_public_path__ + "static/media/beacon.3a307ce8727a9d92d38db861aa8b7b27.svg";
export { ForwardRef as ReactComponent };